<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<div class="edit-idiomas-container" [ngClass]="{ zonaoculta: loading === true }">
  <!-- Botones de acción siguiendo el patrón del proyecto -->
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <!-- Contenedor del accordion -->
  <div class="contenido-traducciones">
    <div class="titulo-idioma-section">
      <h4 class="text-blue h4">{{ nombreIdioma }} <span class="codigo-idioma">({{ codigoIdioma }})</span></h4>
    </div>

    <!-- Mensaje cuando no hay datos -->
    <div *ngIf="!secciones || secciones.length === 0" class="sin-datos">
      <mat-icon class="icon-sin-datos">info</mat-icon>
      <p>{{ 'editIdiomas.noTraducciones' | translate }}</p>
      <p class="detalle-sin-datos">
        {{ 'editIdiomas.cargaDesdeAPI' | translate }} <strong>{{ codigoIdioma }}</strong> {{ 'editIdiomas.recursosDisponibles' | translate }}
      </p>
    </div>

    <!-- Accordion con las secciones -->
    <mat-accordion *ngIf="secciones && secciones.length > 0" [multi]="false">
      <mat-expansion-panel
        *ngFor="let seccion of secciones; let i = index"
        [expanded]="seccion.expandida"
        class="seccion-panel"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="titulo-seccion">
            {{ seccion.nombre }}
            <span class="contador-traducciones">({{ seccion.traducciones.length }})</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <!-- Contenido de la sección: botón Guía visual e tabla de traducciones -->
        <div class="contenido-seccion">
          <!-- Botón Guía visual dentro da sanfona, antes de todas as subcategorias -->
          <div class="guia-visual-container">
            <button
              mat-stroked-button
              type="button"
              class="btn-guia-visual"
              (click)="abrirGuiaVisual(seccion)"
            >
              <mat-icon>photo_library</mat-icon>
              {{ 'editIdiomas.guiaVisual' | translate }}
            </button>
          </div>

          <!-- Tabla de traducciones -->
          <div class="tabla-traducciones-wrapper">
          <ng-container *ngFor="let traduccion of seccion.traducciones; let i = index">
            <!-- Separador de subcategoría -->
            <div *ngIf="traduccion.esSeparador" class="subcategoria-container">
              <div class="separador-subcategoria" [ngClass]="{
                'subcat-principal': traduccion.esSubcategoriaPrincipal,
                'subcat-aninhada': traduccion.esSubcategoriaAninhada
              }">
                <!-- Todas as subcategorias têm accordion -->
                <div class="subcategoria-titulo clickable" 
                     (click)="toggleSubcategoria(traduccion.nombreSubcategoria)">
                  <mat-icon class="arrow-icon" [class.expanded]="isSubcategoriaExpandida(traduccion.nombreSubcategoria)">keyboard_arrow_right</mat-icon>
                  <mat-icon>label</mat-icon>
                  <span>{{ traduccion.nombreSubcategoria }}</span>
                </div>
              </div>
              
              <!-- Tabela com cabeçalhos dentro da subcategoria (apenas quando expandida) -->
              <div *ngIf="isSubcategoriaExpandida(traduccion.nombreSubcategoria)" class="subcategoria-tabla">
                <table class="traducciones-table">
                  <thead>
                    <tr>
                      <th class="col-clave">{{ 'editIdiomas.palabraClave' | translate }}</th>
                      <th class="col-traduccion">{{ 'editIdiomas.traduccion' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Buscar todos os campos desta subcategoria -->
                    <ng-container *ngFor="let campo of seccion.traducciones; let j = index">
                      <tr *ngIf="!campo.esSeparador && pertenceASubcategoria(seccion.traducciones, j, traduccion.nombreSubcategoria)">
                        <td class="col-clave">
                          <span class="palabra-clave">{{ campo.clave }}</span>
                        </td>
                        <td class="col-traduccion">
                          <mat-form-field appearance="outline" class="input-traduccion">
                            <textarea
                              matInput
                              [(ngModel)]="campo.valor"
                              (ngModelChange)="onTraduccionChange(campo)"
                              rows="2"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="5"
                            ></textarea>
                          </mat-form-field>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
          
          <!-- Campos que não pertencem a nenhuma subcategoria (tabela única com cabeçalhos) -->
          <ng-container *ngIf="obterCamposSinSubcategoria(seccion.traducciones).length > 0">
            <div class="tabla-sin-subcategoria">
              <table class="traducciones-table">
                <thead>
                  <tr>
                    <th class="col-clave">{{ 'editIdiomas.palabraClave' | translate }}</th>
                    <th class="col-traduccion">{{ 'editIdiomas.traduccion' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let campo of obterCamposSinSubcategoria(seccion.traducciones)">
                    <td class="col-clave">
                      <span class="palabra-clave">{{ campo.clave }}</span>
                    </td>
                    <td class="col-traduccion">
                      <mat-form-field appearance="outline" class="input-traduccion">
                        <textarea
                          matInput
                          [(ngModel)]="campo.valor"
                          (ngModelChange)="onTraduccionChange(campo)"
                          rows="2"
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="5"
                        ></textarea>
                      </mat-form-field>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
          </div>
        </div>

        <!-- Galería movida para el modal de Guía visual -->
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <!-- Modal de preview de imagen -->
  <div class="preview-backdrop" *ngIf="previewVisible" (click)="cerrarPreview()">
    <div class="preview-modal" (click)="$event.stopPropagation()">
      <button mat-icon-button class="preview-close" (click)="cerrarPreview()" aria-label="Cerrar preview">
        <mat-icon>close</mat-icon>
      </button>
      <div class="preview-header">
        <mat-icon>image</mat-icon>
        <div class="preview-titles">
          <span class="preview-title">{{ previewNombre }}</span>
          <span class="preview-subtitle">{{ 'editIdiomas.vistaPrevia' | translate }}</span>
        </div>
        <div class="zoom-controls">
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= zoomMin" [matTooltip]="'editIdiomas.zoomMenos' | translate">
            <mat-icon>remove</mat-icon>
          </button>
          <span class="zoom-level">{{ (zoomLevel * 100) | number:'1.0-0' }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= zoomMax" [matTooltip]="'editIdiomas.zoomMas' | translate">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-icon-button (click)="resetZoom()" [matTooltip]="'editIdiomas.resetZoom' | translate">
            <mat-icon>fullscreen_exit</mat-icon>
          </button>
        </div>
      </div>
      <div
        class="preview-content"
        (wheel)="onWheelPreview($event)"
        (pointerdown)="startPan($event)"
        (pointermove)="onPan($event)"
        (pointerup)="endPan()"
        (pointerleave)="endPan()"
        (pointercancel)="endPan()"
        [class.is-panning]="isPanning"
      >
        <button
          class="preview-nav prev"
          type="button"
          mat-icon-button
          (click)="prevFoto()"
          [disabled]="!temAnterior()"
          [attr.aria-label]="'editIdiomas.anterior' | translate"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>

        <div
          class="preview-image-wrapper"
          [style.transform]="'translate(' + panX + 'px,' + panY + 'px) scale(' + zoomLevel + ')'"
        >
          <img
            [src]="previewUrl"
            [alt]="previewNombre"
            [style.width.%]="zoomLevel * 100"
          />
        </div>

        <button
          class="preview-nav next"
          type="button"
          mat-icon-button
          (click)="nextFoto()"
          [disabled]="!temProximo()"
          [attr.aria-label]="'editIdiomas.siguiente' | translate"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de Guía Visual -->
  <div class="guia-backdrop" *ngIf="guiaVisible" (click)="cerrarGuiaVisual()">
    <div class="guia-modal" (click)="$event.stopPropagation()">
      <button 
        mat-icon-button 
        class="guia-close-floating"
        (click)="cerrarGuiaVisual()"
        [attr.aria-label]="'editIdiomas.cerrarGuiaVisual' | translate">
        <mat-icon>close</mat-icon>
      </button>
      <div class="guia-header">
        <div class="guia-titles">
          <mat-icon>photo_library</mat-icon>
          <div class="guia-textos">
            <span class="guia-title">{{ guiaSeccion?.nombre || ('editIdiomas.guiaVisual' | translate) }}</span>
            <span class="guia-subtitle">{{ 'editIdiomas.imagenesReferencia' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="guia-body">
        <div class="galeria-fotos" *ngIf="guiaSeccion && getFotosSeccion(guiaSeccion.nombre).length > 0; else sinFotosGuia">
          <div class="foto-item" *ngFor="let foto of getFotosSeccion(guiaSeccion.nombre)">
            <div class="foto-preview">
              <img [src]="foto.url" [alt]="foto.nombre" (click)="abrirPreview(foto, guiaSeccion?.nombre)" />
            </div>
            <div class="foto-info">
              <span class="foto-nombre" [matTooltip]="foto.nombre">{{ foto.nombre }}</span>
              <span class="foto-fecha">{{ foto.fechaSubida | date:'short' }}</span>
            </div>
          </div>
        </div>
        <ng-template #sinFotosGuia>
          <div class="sin-fotos">
            <mat-icon>info</mat-icon>
            <p>{{ 'editIdiomas.noImagenes' | translate }}</p>
            <p>{{ 'editIdiomas.agregarArchivos' | translate }} assets/img-idiomas/<strong>{{ guiaSeccion?.nombre || 'seccion' }}</strong>.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
